import {ApiConfigInterface} from '@/interface';
const {
  REACT_APP_API_URL_LOC,
  REACT_APP_API_URL_DEV,
  REACT_APP_API_URL_QA,
  REACT_APP_API_URL_UAT,
  REACT_APP_API_URL_PROD,
  REACT_APP_WEB_APP_URL_LOC,
  REACT_APP_WEB_APP_URL_DEV,
  REACT_APP_WEB_APP_URL_QA,
  REACT_APP_WEB_APP_URL_UAT,
  REACT_APP_WEB_APP_URL_PROD,
  REACT_APP_ENV,
} = process.env;

export const API: ApiConfigInterface = {
  currentEnv: REACT_APP_ENV, // API server environment: <loc, dev, qa, uat, prod>
  baseUrls: {
    loc: REACT_APP_API_URL_LOC as string,
    dev: REACT_APP_API_URL_DEV as string,
    qa: REACT_APP_API_URL_QA as string,
    uat: REACT_APP_API_URL_UAT as string,
    prod: REACT_APP_API_URL_PROD as string,
  },
  webAppUrls: {
    loc: REACT_APP_WEB_APP_URL_LOC as string,
    dev: REACT_APP_WEB_APP_URL_DEV as string,
    qa: REACT_APP_WEB_APP_URL_QA as string,
    uat: REACT_APP_WEB_APP_URL_UAT as string,
    prod: REACT_APP_WEB_APP_URL_PROD as string,
  },
  noAuthUrls: {
    demo: 'api/v1/demo',
    contact: 'api/v1/contact',

    loginOtp: 'api/v1/login-request-otp',
    loginVerifyOTP: 'api/v1/verify-login-otp',
    loginVerifyMFA: 'api/v1/verify-login-mfa',
    loginResendOTP: 'api/v1/resend-login-otp',
    loginResendMFA: 'api/v1/resend-login-mfa',

    signupOtp: 'api/v1/signup-request-otp',
    specialistSignupOtp: 'api/v1/specialist/signup-request-otp',
    signupResendOTP: 'api/v1/resend-signup-otp',
    singupVerifyOTP: 'api/v1/verify-signup-otp',
    signupResendMFA: 'api/v1/resend-signup-mfa',
    signupVerifyMFA: 'api/v1/verify-signup-mfa',
    verifyLicence: 'api/v1/verify-licence',

    appSettingsSpecialization: 'api/v1/app-settings/specialization',
    appSettingsSpecialistList: 'api/v1/app-settings/specialist-list',
    appSettingsCountryList: 'api/v1/app-settings/country-list',
    appSettingsSpecialistFilterOptions: 'api/v1/app-settings/specialist-filter-options',
    publicConsultationUpload: 'api/v1/public/consultation/upload',
    roleFilterOptions: 'api/v1/app-settings/admin-roles',
  },
  authUrls: {
    specialists: 'api/v1/specialists',
    patients: 'api/v1/patients',
    admins: 'api/v1/admins',
    admin: 'api/v1/admin',
    user: 'api/v1/user',
    profile: 'api/v1/profile',

    patientConsultationAnalyzeReport: 'api/v1/patient/consultation/pending/analyze-report',
    patientConsultationAddReport: 'api/v1/patient/consultation/pending/add-report',
    patientConsultationRemoveReport: 'api/v1/patient/consultation/pending/remove-report',

    patientConsultationSpecialist: 'api/v1/patient/consultation/pending/specialist',
    patientConsultationPayment: 'api/v1/patient/consultation/pending/initiate-payment',

    profileRequestOtp: 'api/v1/profile/request-otp',
    profileVerifyOtp: 'api/v1/profile/verify-request-otp',
    profileResendOtp: 'api/v1/profile/resend-request-otp',
    profileSubmitApproval: 'api/v1/profile/submit-approval',
    profileHelp: 'api/v1/profile/help',
    patientSpecialist: 'api/v1/patient/specialists',
    patientFavouriteDoctor: 'api/v1/patient/favourite-doctor',
    patientRecentCases: 'api/v1/patient/consultation/recent-cases',
    patientSettingExport: 'api/v1/accounts/export',
    patientDeletion: 'api/v1/accounts/delete',
    CancelPatientData: 'api/v1/accounts/cancel-deletion',
    newConsulationCheck: 'api/v1/patient/consultation/awating-response',

    pendingConsultationcase: 'api/v1/patient/consultation/pending-case',

    consultationList: 'api/v1/patient/consultations',

    uploadAdditionalConsultationFiles: 'api/v1/patient/consultation/upload-additional-documents',
    uploadAdditionalConsultationFiles2: 'api/v1/patient/consultation/upload-additional-documents2',
    removeAdditionalConsultationDocument: 'api/v1/patient/consultation/remove-document',
    submitFeedbackAndRating: 'api/v1/patient/consultation/feedback',
    cancelConsultation: 'api/v1/patient/consultation/cancel',
    followUpConsultation: 'api/v1/patient/consultation/follow-up',
    referralConsultation: 'api/v1/patient/consultation/referral',
    manualCategorySelection: 'api/v1/patient/consultation/manual-category-selection',
    getPaymentReceipt: 'api/v1/patient/consultation/payment-receipt',

    specialistDashboardStats: 'api/v1/specialist/dashboard-stats',
    specialistConsultationList: 'api/v1/specialist/consultations',
    specialistConsultationPatient: 'api/v1/specialist/consultation/patient',
    specialistConsultationSummary: 'api/v1/specialist/consultation',
    specialistConsultationAdditionalDocuments: 'api/v1/specialist/consultation/specialist-documents',
    scheduleMeet: 'api/v1/meetings/schedule',
    specialistListForRefferal: 'api/v1/specialist/list',
    specialistDetails: 'api/v1/specialist/',
    hospitalDetails: 'api/v1/hospital',
    specialistFeedback: 'api/v1/specialist/feeback',
    specialistPayments: 'api/v1/specialist/payments',
    apiChatMessages: 'api/v1/chat/messages',

    adminRoles: 'api/v1/admin/roles',
    adminAccessModules: 'api/v1/admin/access-modules',
    adminAccessModulesAll: 'api/v1/admin/access-modules/all',
    document: 'api/v1/document/',
    adminPatientConsultations: 'api/v1/admin/patient/consulations',

    wsToken: 'api/v1/ws-token',
    auditLogs: 'api/v1/logs',
    auditLogsExport: 'api/v1/logs/export',
    filters: 'api/v1/filters',
    category: 'api/v1/category',
    popularSpecialists: 'api/v1/admin/specialist',
    popularityLimit: 'api/v1/app-settings/popularity-limit',
    overrideSpecialistPopularity: 'api/v1/admin/specialist/popularity',
    supportAdminTickets: 'api/v1/support-admin/tickets',
    supportAdminReply: 'api/v1/support-admin/reply',
    supportAdminSpam: 'api/v1/support-admin/spam',
    patientAccountTickets: 'api/v1/account/patients/tickets',
    patientAccountExport: 'api/v1/account/patient/export',
    patientAccountDeletion: 'api/v1/account/patient',
    patientAccountHoldDeletion: 'api/v1/account/patient/hold-deletion',
    patientAccountResumeDeletion: 'api/v1/account/patient/resume-deletion',

    hospitalPointOfContact: 'api/v1/hospital-poc',
    hospitalProfile: 'api/v1/hospital/profile',
    hospitalHelp: 'api/v1/hospital/help',

    hospitalSpecialists: 'api/v1/hospital/specialist',
    hospitalSpecialistsList: 'api/v1/hospital-specialist',
    hospitalSpecialistAll: 'api/v1/hospital/specialist/all',
    hospitalConsultationList: 'api/v1/hospital/consultation',
    hospitalConsultationAssignSpecialist: 'api/v1/hospital/consultation/assign-specialist',

    specialistAdminConsultationList: 'api/v1/admin/specialist/consultation',
    specialistAdminOnboardingList: 'api/v1/admin/specialist/onboarding',
    specialistAdminProfile: 'api/v1/admin/specialist/profile',

    financePayments: 'api/v1/finance/payments',
    financeRefundPayment: 'api/v1/finance/refund-payment',
    financeSpecialistPayouts: 'api/v1/finance/specialist-payouts',
    financeChangePayoutStatus: 'api/v1/finance/change-payout-status',
    specialistInvitation: 'api/v1/specialist/invitation',
    specialistBooking: 'api/v1/patient/specialist/booking',
    proceedWithAiRecommendedSpecialist: 'api/v1/patient/consultation/pending/proceed-with-ai-recommended-specialist',

    assignHospitalSpecialist: 'api/v1/patient/consultation/assign-hospital-specialist',
    selectHospitalSpecialist: 'api/v1/patient/consultation/select-hospital-specialist',
    hospitalSpecializationList: 'api/v1/patient/hospital/specialization-list',

    notifications: 'api/v1/notifications',
    hospitalList: 'api/v1/hospital/list',
    markAllNotificationsAsRead: 'api/v1/notifications/mark-all-as-read',
    adminToggleLicenceVerification: 'api/v1/admin/settings/toggle-licence-verification',
    adminGetLicenceVerificationMode: 'api/v1/app-settings/licence-verification-mode',

    addConsultationQuery: 'api/v1/patient/consultation/add-consultation-query',
    secondOpinionReport: 'api/v1/specialist/consultation/report',
    hospitalEnrichment: 'api/v1/hospital-enrichment',
    logout: 'api/v1/logout',
    accountTicketDetails: 'api/v1/profile/account-ticket-status',

    // Speech to Text API
    speechTranscribe: 'api/v1/speech/transcribe',

    // Video Consultation Integrations
    providers: 'api/v1/providers',
    meetingDetails: 'api/v1/meetings',
    meetingCancel: 'api/v1/meetings',
  },
};

